export const PAGE_NOT_FOUND_ERROR_MESSAGE = 'Page Not Found';
export const NOT_FOUND_ERROR_CODE = '404';

export const AUTHORIZATION_ERROR_MESSAGE = 'You are not authorized to access this page';
export const AUTHORIZATION_ERROR_CODE = '403';

export const INTERNAL_SERVER_ERROR_CODE = '500';
